<template>
  <div class="m-4 text-left pl-4 pr-4" style="background-color: white !important;">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <b-button class="mt-4 ml-0" variant="outline-ligth"  @click="mostrarTipoHistoriaClinica(0)">
            <b-icon icon="arrow-left-circle"></b-icon>
          </b-button>
          <p
        class="solo-primera-mayus mt-4"
        style="font-size: 2em; font-family: 'Silene'"
      >
        Historia clínica emergencia
      </p>
      </div>
      <img src="@/assets/Imagotipo azul_b.png" alt="" style="width: 10em; height: 4em;">
    </div>

    <div class="p-4 mt-3" style="font-size: .85em; line-height: 2; background-color: #FBF3DE; border-radius: 10px; padding-left: 3% !important;">
     <DatosCabecera
        :persona="infoPaciente.persona"      
      ></DatosCabecera>
    </div>

    <hr>

    <b-form v-on:submit.prevent="enviarFormulario">
      <div class="d-flex">
      <img class="img_subtitle" src="@/assets/hc/datos.png" alt="">
      <p class="subtitle">Datos del paciente</p>
    </div>
    
        <datos-paciente-h-c
            :persona="infoPaciente.persona"
            :listaEnterarse="listaEnterarse"
            :listaSexo="listaSexo"
            :cargandoPlanes.sync="cargandoPlanes"
            :cargandoCercania.sync="cargandoCercania"
            :cargandoConfianza.sync="cargandoConfianza"
            :cargandoMedio.sync="cargandoMedio"
        ></datos-paciente-h-c>

        <hr>

<div class="d-flex">
  <img class="img_subtitle" src="@/assets/hc/datos.png" alt="">
  <p class="subtitle">¿Cómo te enteraste de dentalia?</p>
  <div class="mt-1 pl-1"><validacion></validacion></div>
</div>

<ComoTeEnteraste
  :persona="infoPaciente.persona"
  :listaEnterarse="listaEnterarse"
  :listaSexo="listaSexo"
  :cargandoPlanes.sync="cargandoPlanes"
  :cargandoCercania.sync="cargandoCercania"
  :cargandoConfianza.sync="cargandoConfianza"
  :cargandoMedio.sync="cargandoMedio"
></ComoTeEnteraste>

<hr>

<div class="d-flex">
      <img class="img_subtitle" src="@/assets/hc/datos.png" alt="">
      <p class="subtitle">Datos médicos</p>
    </div>

    <DatosMedicos
      :listaFormulario.sync="listaFormulario"  
    ></DatosMedicos>

    <hr>

    <div class="mt-4">
      <p class="text-justify">
              De conformidad con la norma oficial mexicana número
              NOM-004-SSA3-2012, los expedientes clínicos son propiedad del
              prestador de servicios que los genera, en ese tenor, no se podrán
              entregar constancias o documentos que forman parte del mismo, ni
              tampoco copia alguna, incluyendo estudios, radiografías, modelos,
              etc.
               El paciente como propietario de la información que
              proporciona para su atención odontológica y al ser beneficiario de
              los servicios médicos, tiene derecho de titularidad sobre la
              información para la protección de su salud, así como para la
              protección de la confidencialidad de sus datos en términos de
              nuestro aviso de privacidad.

              Manifiesto que todos los datos en la presente solicitud
              fueron declarados por mí, son verídicos y correctos.
            </p>        
      <div class="d-flex justify-content-center mt-3 mi-componente">        
        <p class="mr-2 semibold">He leído y acepto el aviso de privacidad.</p>
        <b-form-checkbox
           class="mi-checkbox-unico"
          name="terminos"
          v-model="infoPaciente.persona.aceptaAvisoPrivacidad"
          :state="
            infoPaciente.persona.aceptaAvisoPrivacidad != '' &&
            infoPaciente.persona.aceptaAvisoPrivacidad != null
          "
          required
          >
        </b-form-checkbox>
      </div>   
      
      <div class="text-center">
        <b-button
          class="mt-4 mb-4 pl-3 pr-3"
          type="submit"
          pill
          variant="primary"
          style="height: 2.5em"
          v-if="!enviando && (activarGuardar || edicionLinkUsuario)"
        >
          <p style="font-weight: 600; color: white !important;">Guardar</p>
        </b-button>
        <b-button variant="primary" v-show="enviando" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </div>
    </div>
    </b-form>
  </div>
</template>
<script>
import VueNotifications from "vue-notifications";
import DatosCabecera from "./DatosCabecera.vue";
import DatosPacienteHC from "@/views/perfilPacientes/historialClinica/DatosPacienteHC";
import ComoTeEnteraste from "./ComoTeEnteraste.vue";
import DatosMedicos from "./DatosMedicos.vue";
export default {
  name: "historiaEmergenciaV2",
  components: {DatosPacienteHC,ComoTeEnteraste,DatosMedicos,DatosCabecera},
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      existeFirma: false,
      edicionLinkUsuario: false,
      urlBase: null,
      idPaciente: null,
      nombrePlan: "",
      idPlan: null,
      listaEnterarse: [],
      listaSexo:[],
      infoPaciente: {
        persona: {
          idPersona: null,
          apellidoMaterno: "",
          apellidoPaterno: "",
          nombre: "",
          fechaNacimiento: "",
          sexo: "",
          correo: "",
          telefono: "",
          casa: "",
          trabajo: "",
        },


      },
      enviando: false,
      verFirma: null,
      cargandoDatosForm: true,
      cargandoMedio: true,
      cargandoCercania: true,
      cargandoConfianza: true,
      cargandoDolor: true,
      cargandoPlanes:true,
      listaFormulario: [],
      formato: false,
      fechaActual: null
    };
  },
  props: {
    idPacienteProp: Number,
    idClinicaProp: Number,
    idHistoriaClinica: Number,
    activarGuardar: Boolean,
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    this.fechaActual = new Date();
    this.idClinica=this.$localStorageService.getIdClinica()
    this.idPaciente = this.$route.params.id;
    this.urlBase = this.$api;

    if (this.idPacienteProp !== undefined && this.idClinicaProp !== undefined) {
      this.idPaciente = this.idPacienteProp;

      this.edicionLinkUsuario = true;
      this.urlBase = this.$baseURL + "/";
    }

    this.verFirma = await this.vadicionActivarEceClinica();
    //traemos historial, sexo y enterarse por grupo
    this.traerPlanes();
    this.traerMedio();

    this.traerFormulario()


  },
  methods: {
    mostrarTipoHistoriaClinica(tipoHc){
      this.$emit("mostrarTipoHistoriaClinica", tipoHc);
    },
    traerFormulario() {

      let urlForm =
          this.urlBase + "paciente/hc/obtenerFormularioEmergencia";

      this.$http
          .get(urlForm, this.headers)
          .then((response) => {

            this.listaFormulario = response.data.data

          }).finally(() => {
        this.cargandoDatosForm = false;
        this.traerDatosPaciente();

      });
    },
    obtenerListaSexo() {
      let peticion = this.urlBase + "paciente/catalogo/listaSexo";
      this.$http
          .get(peticion, this.headers)
          .then((response) => {
            this.listaSexo = response.data.data;
          });
    },
    async validacionActivaHerramientasHdx(){
      return await this.$http
          .get(this.urlBase +"rutaExpediente/validacionActivaHdx")
    },
    async vadicionActivarEceClinica() {
      const parametros = {idClinica: this.idClinica}
      return await this.$http.post(
          this.$api + "catalogos/obtenerClinicasActivasECE", parametros
      );
    },
    verificarExisteFirma(value) {
      this.existeFirma = value;
    },
    traerPlanes() {
      this.cargandoPlanes = true;
      const datos = {
        idPaciente: this.idPaciente
      }
      let urlPlanes =
        this.urlBase +
        "paciente/perfiles/obtenerPlanesPaciente";

      this.$http
        .post(urlPlanes, datos)
        .then((response) => {
          if (response.data.data) {
            let idPlan = null;
            let nombrePlan = "";
            response.data.data.forEach((plan) => {
              idPlan = plan.id;
              nombrePlan = plan.nombre;
            });
            this.idPlan = idPlan;
            this.nombrePlan = nombrePlan;
            this.cargandoPlanes = false;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
          this.cargandoPlanes = false;
        });
    },
    traerMedio() {
      let urlMedio = this.urlBase + "paciente/catalogo/listaMedio";
      this.$http
        .get(urlMedio)
        .then((response) => {
          if (response.data.data) {
            this.listaEnterarse = response.data.data;
            this.validarIdMedioActivo();
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        })
        .finally(() => {
          this.cargandoMedio = false;
        });
    },

    /*
    * Función para validar si el idMedio registrado por el paciente
    * sigue estando activo dentro de las opciones que se encuentran en la
    * pregunta ¿Cómo te enteraste de Dentalia?
    *
    * En caso de que no se resetea el valor idMedio de la Persona(Paciente) en
    * null para obligar a responder de nuevo la pregunta
    */
    validarIdMedioActivo() {
      const idMedio = this.infoPaciente?.persona?.idMedio;
      if (idMedio == null || !this.listaEnterarse?.length) return;
      const existe = this.listaEnterarse.some(g => g.options.some(o => o.idMedio === idMedio));
      if (!existe) this.infoPaciente.persona.idMedio = null;
    },

    traerDatosPaciente() {

      if (this.idHistoriaClinica === undefined || this.idHistoriaClinica === null){
        this.idHistoriaClinica = 0
      }

      const params = {
        idPaciente: this.idPaciente,
        idHistoriaClinica: this.idHistoriaClinica
      }
      let urlPaciente =
          this.urlBase + "paciente/hc/obtenerDatosParametricos";

      this.$http
        .post(urlPaciente, params)
        .then((response) => {
          if (response.data.data) {
            this.infoPaciente = response.data.data;
            this.validarIdMedioActivo();

            this.listaFormulario.forEach(l => {
              l.enfermedades.forEach(e => {
                this.infoPaciente.enfermedadesGuardar.forEach(g => {
                  if (e.idEnfermedadSistemica === g.idEnfermedadSistemica){
                    e.valor = g.valor;
                  }
                })
              })
            })

            //persona
            this.infoPaciente.persona.fechaNacimiento = this.$global.traerFechaLocal(
              response.data.data.persona.fechaNacimiento
            );
          }
        })
        .catch((err) => {
          console.error(err);
        }).finally(()=> {
        if (this.infoPaciente.persona.fechaModificacion == null) {
          this.formato = true
          this.infoPaciente.persona.fechaModificacion = this.$global.traerFechaLocal(
              this.$global.traerFecha()
          );
        }
      });
    },


    enviarFormulario() {
      if (!this.validarDatos()) {
        this.guardarEditarhistoria();
      }
    },
    guardarEditarhistoria() {
      this.listaEnviar = [];

      let formularioValido = true;
      let enfermedadRequerida = [];

      this.listaFormulario.forEach(l =>{
        l.enfermedades.forEach(e => {
          if (e.valor !== null){
            this.listaEnviar.push({
              idEnfermedadSistemica: e.idEnfermedadSistemica,
              valor: e.valor
            })
          }else{
            if ((e.valor === null || e.valor === '') && e. requerido){
              formularioValido = false;
              enfermedadRequerida.push(e.descripcionEnfermedad);
            }
          }
        })
      })

      if (!formularioValido){
        this.$swal({
          icon: "warning",
          html: `Falta llenar campo requerido en:</br> <strong> ${enfermedadRequerida} </strong>, </br> Por favor llene todos los campos obligatorios `,
          confirmButtonColor: "#0e6ba9",
          cancelButtonColor: "#8e8e8e",
          confirmButtonText: "Ok",
          showCancelButton: true,
        })
      }else{
        this.infoPaciente.enfermedadesGuardar = this.listaEnviar;

        this.infoPaciente.persona.fechaNacimiento = this.infoPaciente.persona.fechaNacimiento
        this.infoPaciente.persona.fechaNacimiento = this.$moment(
            this.infoPaciente.persona.fechaNacimiento
        )
        if (this.formato){
          this.infoPaciente.persona.fechaModificacion = this.infoPaciente.persona.fechaModificacion
          this.infoPaciente.persona.fechaModificacion = this.$moment(
              this.infoPaciente.persona.fechaModificacion
          )
        }
        this.infoPaciente.persona.idClinica = this.edicionLinkUsuario ? this.$route.params.idClinica : this.$localStorageService.getIdClinica();
        this.infoPaciente.persona.edicionLink = this.edicionLinkUsuario ? true : false;
        this.infoPaciente.persona.esEmergencia = true;




        this.$swal({
          icon: "warning",
          text: "Estoy de acuerdo en que dentalia guarde mis datos de privacidad.",
          confirmButtonColor: "#0e6ba9",
          cancelButtonColor: "#8e8e8e",
          confirmButtonText: "Guardar",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.enviando = true;
            this.enviarDatos();
          }
        });
      }
    },
    enviarDatos() {


      let urlEditar = this.urlBase + "paciente/historialDinamico";
      this.infoPaciente.idPaciente = this.idPaciente;

      this.$http
          .post(urlEditar, this.infoPaciente, this.headers)
          .then((response) => {
            if (response.status === 200) {
              this.enviando = false;
              this.$swal({
                icon: "success",
                text: "Se guardó su historial clínico correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            }
          })
          .catch((err) => {
            this.enviando = false;
            this.errorEnvio(err);
          });
    },
    validarDatos() {
      let error = false;
      if (this.infoPaciente.persona.idMedio == null) {
        this.$swal({
          icon: "error",
          text:
              "Debe seleccionar una opción de '¿Cómo te enteraste de dentalia?'",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
       /* if (this.verFirma.data.data && !this.existeFirma) {
          this.$swal({
            icon: "error",
            text:
                "Debe ingresar una firma.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          error = true;
        }*/
        error = true;
      }
      return error;
    },
    acomodarDatos() {
      let persona = {
        "casa": this.infoPaciente.persona.casa,
        "trabajo": this.infoPaciente.persona.trabajo,
        "telefono": this.infoPaciente.persona.telefono,
        "correo": this.infoPaciente.persona.correo,
        "sexo": this.infoPaciente.persona.sexo,
        idPersona: this.infoPaciente.persona.idPersona,
      };


      let perfil = {
        idPersonaPerfil: this.infoPaciente.perfil.idPersonaPerfil,
        sobrenombre: this.infoPaciente.perfil.sobrenombre.trim(),
        idPersona: this.infoPaciente.persona.idPersona,
      };



      let historial = this.infoPaciente.historia;
      historial.idPaciente = this.idPaciente;


      if (this.edicionLinkUsuario) {
        historial.idClinica = this.infoPaciente.historia.idClinica;
      } else {
        historial.idClinica =
            this.infoPaciente.historia.idClinica != null
                ? this.infoPaciente.historia.idClinica
                : this.$localStorageService.getIdClinica();
      }

      historial.idPlan =
        this.infoPaciente.historia.idPlan != null
          ? this.infoPaciente.historia.idPlan
          : this.idPlan;
  /*    delete historial.fechaModificacion;*/
      delete historial.nombrePlan;

      if (this.edicionLinkUsuario) {
        historial.usuarioLogeado = 1;
      } else {
        historial.usuarioLogeado = this.$localStorageService.getIdUsuario();
      }

      return {
        persona: persona,
        perfil: perfil,
        historia: historial,
      };
    },
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>
<style scoped>
p{
  margin: 0px;
  padding: 0px;
  color: #0046A2 !important;
}

.semibold{
  font-weight: 600;
}

.subtitle{
  font-size: 1.5em;
  font-weight: 700;
}

.img_subtitle{
  width: 2.4em;
  height: 2.2em;
  margin-right: 1%;
}

.mi-componente /deep/ .mi-checkbox-unico .custom-control-label::before {
  background-color: transparent !important;
  border: 2px solid #012247 !important;
  width: 1.5em !important;
  height: 1.5em !important;

}

.mi-componente /deep/ .mi-checkbox-unico .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #C4E39B !important;
  border-color: #012247 !important;
}

.mi-componente /deep/ .mi-checkbox-unico .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23012247' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e") !important;
  width: 1.5em !important;
  height: 1.5em !important;
}
</style>
